<script setup>
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import { useColor } from '@js/composables/color';
import { computed } from 'vue';

const {
    pillValue,
    type = 'primary',
    align = 'left',
    leftIcon,
    customBackgroundColor = undefined,
    customColor = undefined,
} = defineProps({
    pillValue: {
        type: [String, Number],
        required: true,
    },
    type: {
        type: String,
        required: false,
    },
    align: {
        type: String,
        required: false,
    },
    leftIcon: {
        required: false,
        default: null,
    },
    customBackgroundColor: {
        type: String,
        required: false,
    },
    customColor: {
        type: String,
        required: false,
    },
});

const { getContrastColor } = useColor();

const style = computed(() => {
    return {
        ...(customBackgroundColor
            ? {
                  'background-color': customBackgroundColor,
                  color: customColor ?? getContrastColor(customBackgroundColor),
              }
            : {}),
    };
});
</script>

<template>
    <BaseCell :align="align">
        <div
            class="inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-bold whitespace-nowrap"
            :class="{
                'bg-indigo-600 text-white':
                    type === 'primary' && !customBackgroundColor,
                'bg-gray-200 text-indigo-600':
                    type === 'secondary' && !customBackgroundColor,
                'bg-green-500 text-white':
                    type === 'success' && !customBackgroundColor,
                'bg-yellow-500 text-white':
                    type === 'warning' && !customBackgroundColor,
                'bg-red-500 text-white':
                    type === 'danger' && !customBackgroundColor,
                'bg-black text-white':
                    type === 'dark' && !customBackgroundColor,
            }"
            :style="style"
        >
            <component v-if="leftIcon" :is="leftIcon" class="size-5" />

            {{ pillValue }}
        </div>

        <div v-if="$slots.actions" class="flex gap-2">
            <slot name="actions" />
        </div>
    </BaseCell>
</template>
